import React from 'react';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ResultItem from './ResultItem';
import { Card, Autocomplete, FakeText } from '@totalsoft/rocket-ui';
import { PaginationFilter } from 'features/simulator/SimulatorStyles';
import PaginationWrapper from 'components/common/PaginationWrapper';

const SimulatorResult = ({
  assets,
  loadAssetImage,
  images,
  pager,
  onRefresh,
  onChangePage,
  onAssetSelected,
  savingOffer,
  t,
  filterValues,
  handleFiltersChange
}) => {
  return (
    <Grid container spacing={4}>
      {assets.loading && assets.data && assets.data.length === 0 ? (
        <Grid item xs={12}>
          <FakeText lines={15} onPaper />
        </Grid>
      ) : (
        assets.data &&
        assets.data.length > 0 && (
          <>
            {
              <PaginationFilter item xs={12}>
                <Card disablePadding>
                  <Grid container justifyContent='end' alignItems='center' gap={1} py={1} px={4}>
                    <Typography variant='caption'>{t('Simulator.Filters.OrderByMonthlyRate')}</Typography>
                    <Autocomplete
                      value={filterValues.isSortDescending}
                      onChange={handleFiltersChange('isSortDescending')}
                      isSearchable={false}
                      isClearablelearable={false}
                      simpleValue
                      options={[
                        { id: false, name: t('Simulator.Filters.OrderAscending') },
                        { id: true, name: t('Simulator.Filters.OrderDescending') }
                      ]}
                    />
                    <Grid item>
                      <PaginationWrapper
                        count={assets.totalCount || pager.totalCount}
                        rowsPerPageOptions={[]}
                        pageSize={pager.pageSize}
                        page={pager.page}
                        onPageChange={onChangePage}
                        onRefresh={onRefresh}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </PaginationFilter>
            }
            {assets.data.map((asset, index) => {
              return (
                <ResultItem
                  itemsLoaded={assets.loaded}
                  key={index}
                  item={asset}
                  loadAssetImage={loadAssetImage}
                  images={images}
                  onAssetSelected={onAssetSelected}
                  savingOffer={savingOffer}
                />
              );
            })}
          </>
        )
      )}
    </Grid>
  );
};

SimulatorResult.propTypes = {
  assets: PropTypes.object.isRequired,
  loadAssetImage: PropTypes.func.isRequired,
  images: PropTypes.object.isRequired,
  pager: PropTypes.object.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onAssetSelected: PropTypes.func.isRequired,
  savingOffer: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired,
  handleFiltersChange: PropTypes.func.isRequired
};

export default withTranslation()(SimulatorResult);
